import React, { FC } from 'react';
import { Box, Grid, Text, VStack } from '@chakra-ui/react';
import { ModeSelector } from '@app/screens/liquidity/LiquidityWizard/components/SelectModeStep/components/ModeSelector';
import { ProviderSelector } from './components/ProviderSelector';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';
import { AddLiquidityByProvider } from './components/AddLiquidityByProvider/AddLiquidityByProvider';
import { SelectedPoolSection } from '@app/screens/liquidity/LiquidityWizard/components/SelectModeStep/components/SelectedPoolSection';
import { ManualLiquidityDetails } from '@app/screens/liquidity/LiquidityWizard/components/SelectModeStep/components/ManualLiquidityDetails';
import { SteerLiquidityDetails } from '@app/screens/liquidity/LiquidityWizard/components/SelectModeStep/components/SteerLiquidityDetails';
import { IchiLiquidityDetails } from '@app/screens/liquidity/LiquidityWizard/components/SelectModeStep/components/IchiLiquidityDetails';
import { StrategyDetails } from '@app/screens/liquidity/AddLiquidityV3/components/gamma/StartegyDetails';
import { useScrollTop } from '@app/hooks/other/useScrollTop';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
}

export const SelectModeStep: FC<Props> = ({ mintInfo }) => {
  useScrollTop(true);

  const { provider } = useLiquidityWizardState();

  return (
    <Box mx="auto" w="100%">
      <Grid
        gridTemplateColumns={['1fr', '1fr', '1fr', '1fr 1.3fr']}
        p={0}
        w="100%"
        gap={6}
      >
        <VStack gap={4} alignItems="flex-start">
          <SelectedPoolSection />
          <Text as="h4" fontSize={18} fontWeight={600}>
            Select Mode
          </Text>
          <Text fontSize={14} my={4}>
            You can use manual or auto to manage your positions. If you select
            manual, you can adjust prices to sell your tokens as it reaches a
            certain levels. Or you can use auto, and choose from several
            different pre-set strategies to keep your positions in range.
          </Text>
          <ModeSelector />
          <ProviderSelector mintInfo={mintInfo} />
          <AddLiquidityByProvider mintInfo={mintInfo} />
        </VStack>

        <VStack width="100%" alignItems="flex-start">
          <ManualLiquidityDetails mintInfo={mintInfo} />
          {provider === 'steer' && (
            <SteerLiquidityDetails mintInfo={mintInfo} />
          )}
          <IchiLiquidityDetails mintInfo={mintInfo} />
          <StrategyDetails />
        </VStack>
      </Grid>
    </Box>
  );
};
